import React from 'react';

import FaqSection from '../../components/FaqSection';

function LandingFaq(props) {
  return <FaqSection {...props} />;
}

export default LandingFaq;
